import * as React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import useStyles from "./SettingsPanel.styles";
import ToggleButton from "../shared/ToggleButton";
import { StoreState } from "../../../models/states/StoreState";
import { useThunkDispatch } from "../../../redux/thunks";
import { debugInfoEnabled, debugInfoDisabled } from "../../../redux/actions";
import Radio from "../shared/Radio";
import DockLeftIcon from "../shared/DockLeftIcon";
import DockRightIcon from "../shared/DockRightIcon";
import FloatingIcon from "../shared/FloatingIcon";
import { DockPosition } from "../shared/DockPosition";
import WidgetPanel from "./WidgetPanel";
import { SurveyMode } from "../../../models/enums/SurveyMode";

interface Props {
    dockPosition: DockPosition;
    onChangeDockPosition(position: DockPosition): void;
}

export function SettingsPanel({ onChangeDockPosition, dockPosition }: Props) {
    const containerRef = React.useRef();
    const classes = useStyles({});

    const dispatch = useThunkDispatch();
    const debugInfo = useSelector((state: StoreState) => state.application.debugInfo);

    const applicationMode = useSelector((state: StoreState) => state.application.mode);

    const { t } = useTranslation();

    return (
        <WidgetPanel title={t("debug.panels.settings.title")} containerRef={containerRef}>
            {applicationMode === SurveyMode.Preview && (
                <div className={classes.setting}>
                    <div className={classes.settingLabel}>
                        {t("debug.panels.settings.enableDebugInfo")}
                    </div>
                    <div className={classes.settingValue}>
                        <ToggleButton
                            value={debugInfo}
                            onChange={(v) => dispatch(v ? debugInfoEnabled() : debugInfoDisabled())}
                        />
                    </div>
                </div>
            )}
            <WidgetPanel.Section title={t("debug.panels.settings.display.title")}>
                <div className={classes.setting}>
                    <div className={classes.settingValue} style={{ flex: 1 }}>
                        <Radio value={dockPosition} onChange={onChangeDockPosition}>
                            <Radio.Button
                                value="left"
                                layout="vertical"
                                icon={() => <DockLeftIcon />}
                                text={t("debug.panels.settings.display.dockLeft")}
                            />
                            <Radio.Button
                                value="right"
                                layout="vertical"
                                icon={() => <DockRightIcon />}
                                text={t("debug.panels.settings.display.dockRight")}
                            />
                            <Radio.Button
                                value="floating"
                                layout="vertical"
                                icon={() => <FloatingIcon />}
                                text={t("debug.panels.settings.display.undock")}
                            />
                        </Radio>
                    </div>
                </div>
            </WidgetPanel.Section>
        </WidgetPanel>
    );
}
